import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-safety-observations-view-incidents',
  templateUrl: './safety-observations-view-incidents.component.html',
  styleUrls: ['./safety-observations-view-incidents.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SafetyObservationsViewIncidentsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
